var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import styled from "@mui/system/styled";
import { AppBar, Box, Popper, Tab, Tabs, useMediaQuery, useTheme, } from "@mui/material";
function TabPanel(props) {
    const { children, value } = props, other = __rest(props, ["children", "value"]);
    return (React.createElement("div", Object.assign({ role: "tabpanel", hidden: !value, id: `simple-tabpanel-${0}`, "aria-labelledby": `simple-tab-${0}` }, other), value && (React.createElement(Box, { sx: { p: 3, backgroundColor: "#fff", height: "100vh" } }, children))));
}
const HeaderTabWapper = styled("div")(({ theme }) => {
    return {
        position: "fixed",
        width: "100%",
        zIndex: 1,
        ".css-7e0s21-MuiPaper-root-MuiAppBar-root": {
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
        },
    };
});
const PopupWrapper = styled("div")(({ theme }) => {
    const PopupImg = require("../../assests/images/popup_mobile.svg").default;
    return {
        ".popupDiv": {
            backgroundImage: `url(${PopupImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            height: "20vw",
            width: "40vw",
            WebkitFilter: "drop-shadow(0 5px 5px rgba(0,0,0,.5))",
            zIndex: 1,
            padding: "1em",
        },
        [theme.breakpoints.down(600)]: {
            marginRight: "11vw",
            ".popupDiv": {
                width: "64vw",
                height: "34vw",
            },
        },
        [theme.breakpoints.up(1024)]: {
            ".popupDiv": {
                display: "none",
            },
        },
    };
});
export const HeaderTabsComponent = (props) => {
    var _a;
    const rest = __rest(props, []);
    const theme = useTheme();
    const showText = useMediaQuery(theme.breakpoints.down("md"));
    const [value, setValue] = React.useState(props.selectedTab || 0);
    const [isTrue, setIsTrue] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    let [index, setIndex] = React.useState(0);
    const divRef = React.useRef(null);
    React.useEffect(() => {
        for (const [index, obj] of props.data.entries()) {
            if ("PopupComponent" in obj) {
                setAnchorEl(divRef.current);
                setOpen(true);
                setIndex(index);
            }
        }
    }, [divRef]);
    const handleChange = (event, newValue) => {
        var _a;
        setValue(newValue);
        props === null || props === void 0 ? void 0 : props.callBack(props.data[newValue].text);
        ((_a = props === null || props === void 0 ? void 0 : props.data[newValue]) === null || _a === void 0 ? void 0 : _a.Component) ? setIsTrue(true) : setIsTrue(false);
    };
    const handleClickPopup = (event) => {
        console.log(event);
        setOpen(false);
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const { PopupComponent } = props === null || props === void 0 ? void 0 : props.data[index];
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderTabWapper, Object.assign({}, rest), showText && (React.createElement(Box, { sx: { width: "100%" } },
            React.createElement(Box, null,
                React.createElement(AppBar, { position: "sticky", className: "tabheader" },
                    React.createElement(Tabs, { value: value, onChange: handleChange, variant: props.data.length > 3 ? "scrollable" : "fullWidth", scrollButtons: false }, (_a = props.data) === null || _a === void 0 ? void 0 : _a.map((label, index) => (React.createElement(Tab, { key: index, ref: divRef, sx: { backgroundColor: "#fff" }, label: label.text })))))),
            React.createElement(TabPanel, { value: isTrue }, props.data[value].Component)))),
        PopupComponent && (React.createElement(Popper, { hidden: !showText, open: open, anchorEl: anchorEl, placement: "bottom-start" },
            React.createElement(Box, null,
                React.createElement(PopupWrapper, null,
                    React.createElement("div", { className: "popupDiv" },
                        React.createElement(PopupComponent, { close: handleClickPopup }))))))));
};
